import React, { Component } from 'react';
import TodayView from 'components/finance/TodayView';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as financeAction from 'store/modules/finance';

class TodayViewContainer extends Component {

  componentDidMount() { 
    const {FinanceAction, id} = this.props;
    FinanceAction.getTodayList(id);
  }

  setIsLastThema = () => {
    const {FinanceAction} = this.props;
    FinanceAction.setIsLastThema();
  }

  render() {
    const {todayList, isLastThema, allList} = this.props;
    const {setIsLastThema} = this;

    return (
      <TodayView 
        todayList={todayList} 
        isLastThema={isLastThema}
        setIsLastThema={setIsLastThema}
        allList={allList}
      />
    );
  }
}

export default connect(
  (state) => ({
    allList: state.finance.toJS().allList,
    todayList: state.finance.toJS().todayList,
    isLastThema: state.finance.toJS().isLastThema,
    // lang: state.wow.toJS().lang
  }),
  (dispatch) => ({
    FinanceAction: bindActionCreators(financeAction, dispatch)
  })
)(TodayViewContainer);